import {Store, StoreConfig} from "@datorama/akita";
import {Injectable} from "@angular/core";

export enum CallingState {
  none,
  callingOut,
  callingIn,
  callProcessing,
  callHolding
}

export const videoConstraints: MediaTrackConstraints = {
  width: 480,
  height: 640,
  echoCancellation: true,
  frameRate: 20,
  noiseSuppression: true
};

export enum TypeContact {
  internal = 'internal',
  general = 'general',
}

export interface StateWebphone {
  isPortsipRegistered: boolean;
  isPortsipRegistering: boolean;
  errorCode: string;

  localAudioSrc: string;

  callState: CallingState;

  callingPhoneNumber: string;
  callingPhoneName: string;
  typeContact: TypeContact;

  onSwitchingShop: boolean;
  onChoosingShop: boolean;
  onCreatingTicket: boolean;

  isVideoCall: boolean;
  localVideoSrcObject: MediaStream;
  remoteVideoSrcObject: MediaStream;
  statusCodeEndCall: number;
  onWebSocketClose: boolean;
  enableCallFunc: boolean;
}

const initialState = {
  isPortsipRegistered: false,
  isPortsipRegistering: false,
  errorCode: "",

  localAudioSrc: "",

  callState: CallingState.none,

  callingPhoneNumber: "",
  callingPhoneName: "",

  onChoosingShop: false,
  onCreatingTicket: false,
  onSwitchingShop: false,

  isVideoCall: false,
  localVideoSrcObject: null,
  remoteVideoSrcObject: null,
  statusCodeEndCall: null,
  onWebSocketClose: false,
  enableCallFunc: false,
};

@Injectable({
  providedIn: "root"
})
@StoreConfig({name: 'webphone', resettable: true})
export class WebphoneStore extends Store<StateWebphone> {
  constructor(
  ) {
    super(initialState);
  }

  setPortsipErrorCode(code: string) {
    this.update({errorCode: code});
  }

  setLocalVideo(srcObject: MediaStream) {
    const audioTracks = srcObject.getAudioTracks();
    if (audioTracks.length > 0) {
      srcObject.removeTrack(audioTracks[0]);
    }
    this.update({
      localVideoSrcObject: srcObject
    });
  }

  setRemoteVideo(srcObject: MediaStream) {
    this.update({
      remoteVideoSrcObject: srcObject
    });
  }

  clearVideos(currentLocalVideoSrc: MediaStream, currentRemoteVideoSrc: MediaStream) {
    currentLocalVideoSrc?.getTracks().forEach(track => track.stop());
    currentRemoteVideoSrc?.getTracks().forEach(track => track.stop());
    this.update({
      localVideoSrcObject: null,
      remoteVideoSrcObject: null
    });
  }

}
